import colors from './colors';
import config from './config';
export default {
    colors,
    config,
};
